/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S3_TitleInputs */

const en_guide_large_json_files_s3_title = /** @type {(inputs: Guide_Large_Json_Files_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy 2: Stream Instead of Load`)
};

const ko_guide_large_json_files_s3_title = /** @type {(inputs: Guide_Large_Json_Files_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략 2: 로드 대신 스트리밍`)
};

const ja_guide_large_json_files_s3_title = /** @type {(inputs: Guide_Large_Json_Files_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戦略2：読み込みではなくストリーミング`)
};

/**
* | output |
* | --- |
* | "Strategy 2: Stream Instead of Load" |
*
* @param {Guide_Large_Json_Files_S3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s3_title = /** @type {((inputs?: Guide_Large_Json_Files_S3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s3_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s3_title(inputs)
	return ja_guide_large_json_files_s3_title(inputs)
});